import { BoardFinance } from "../../components/Graphics";


export const BoardFour = () => {
  return <BoardFinance />;
};
